<template>
    <v-container>
        <v-card class="card">
            <v-card-text>
                <v-layout class="d-flex justify-space-between flex-wrap">
                    <v-btn class="transition" color="primary" rounded @click="filter_open = !filter_open">
                        <v-icon small style="margin-right: 10px;">rod-filter</v-icon>
                        Filtrar por:
                        <v-icon :class="{ 'rotate90': filter_open }" small>chevron_right</v-icon>
                    </v-btn>
                    <v-btn color="primary" @click="downloadReport">
                        <v-icon left size="18">
                            mdi-file-chart
                        </v-icon>
                        SALVAR RELATÓRIO
                    </v-btn>
                </v-layout>
                <collapse-transition>
                    <div v-show="filter_open" class="pa-5">
                        <v-row>
                            <v-col cols="3">
                                <v-text-field v-model="filtro.id_produto" label="ID do Produto:"
                                              placeholder="Informe o ID do Produto" outlined
                                              maxlength="500" />
                            </v-col>
                            <v-col cols="3">
                                <v-text-field v-model="filtro.codigo_produto" label="Código do Produto:"
                                              placeholder="Informe o Código do Produto" outlined
                                              maxlength="500" />
                            </v-col>
                            <v-col cols="3">
                                <v-text-field v-model="filtro.nome_produto" label="Nome do Produto:"
                                              placeholder="Informe o Nome do Produto" outlined
                                              maxlength="500" />
                            </v-col>
                            <v-col cols="3">
                                <DynamicSelect v-model="filtro.id_flavor" label="Marcas:" id="FlavorSelect"
                                               placeholder="Selecione a Marca" endpoint="/dynamic-selects/flavors/id"
                                               multiple="true" item-text="label" item-value="id" />
                            </v-col>
                            <v-col cols="3">
                                <DynamicSelect v-model="filtro.id_empresa_newcon" label="Empresa:" id="EmpresaSelect"
                                               placeholder="Selecione a Empresa" endpoint="/dynamic-selects/empresas/id"
                                               :multiple="true" item-text="label" item-value="id" />
                            </v-col>
                            <v-col cols="3">
                                <DynamicSelect v-model="filtro.id_modalidade" label="Modalidade:" id="ModalidadeSelect"
                                               placeholder="Selecione a Modalidade" endpoint="/dynamic-selects/modalidades/id"
                                               :multiple="true" item-text="label" item-value="id" />
                            </v-col>
                            <v-col cols="3">
                                <v-text-field v-model="filtro.id_unidade_negocio" label="Unidade de Negócio:"
                                              placeholder="Informe a Unidade de Negócio" outlined />
                            </v-col>
                        </v-row>
                        <v-row class="justify-end">
                            <v-btn color="secondary" class="mr-4" @click="resetFilter">Limpar</v-btn>
                            <v-btn color="primary mr-n1" @click="filtrar">Filtrar</v-btn>
                        </v-row>
                    </div>
                </collapse-transition>
                <DataTable :headers="headers" :params="params" :filter="custom_filter"
                           url="/painel/datatable/produtos">
                    <template v-slot:items="{item}">
                        <td class="text-center">
                            <v-menu :close-on-content-click="false">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn color="primary" class="btn-acoes"
                                           v-bind="attrs"
                                           style="width: 52px;
                                         height: 48px;
                                         padding: 5px;
                                         margin: 10px;
                                         min-width: 48px;"
                                           v-on="on">
                                        <v-icon>mdi-dots-horizontal</v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item>
                                        <v-list-item-title class="font-weight-bold">O que deseja fazer?</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="editar(item)">
                                        <v-list-item-title>Editar</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="confirmExcluir(item.id_cadastro)">
                                        <v-list-item-title>Excluir</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </td>
                        <td class="text-center">{{ item.id_produto }}</td>
                        <td class="text-center">
                            <span class="codigo-background">{{ item.codigo_produto }}</span>
                        </td>
                        <td>{{ item.nome_produto }}</td>
                        <td>
                            {{ item.flavor ? item.flavor.nome_amigavel : ' - ' }}
                        </td>
                        <td>{{ item.empresa.cd_empresa_newcon + ' - ' + item.empresa.nm_empresa_newcon }}</td>
                        <td>{{ item.modalidade ? item.modalidade.nome_modalidade : 'Sem Modalidade' }}</td>
                        <td class="text-center">{{ item.id_unidade_negocio || ' - ' }}</td>
                    </template>
                </DataTable>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
  import { AlertTypes } from '../../../plugins/alerts_types'
  import { alert, notification } from '../../../plugins/helpers'
  import * as Qs from 'qs'

  export default {
    name: 'ListagemProdutos',
    props: {
      atualizaListagem: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        filter_open: false,
        headers: [
          { text: 'Ações', value: '', align: 'center', sortable: false },
          { text: 'ID do Produto', value: 'id_produto', align: 'center' },
          { text: 'Código do Produto', value: 'codigo_produto', align: 'center' },
          { text: 'Nome do Produto', value: 'nome_produto' },
          { text: 'Marca', value: 'id_flavor' },
          { text: 'Empresa', value: 'id_empresa_newcon' },
          { text: 'Modalidade', value: 'id_modalidade' },
          { text: 'Un. de Negócio', value: 'id_unidade_negocio', align: 'center' }
        ],
        params: {
          pagination: {
            page: 1,
            rowsPerPage: 15,
            items_grid: 15,
            sortBy: 'id_cadastro',
            descending: false
          }
        },
        filtro: {
          id_produto: null,
          codigo_produto: '',
          nome_produto: '',
          id_flavor: [],
          id_empresa_newcon: [],
          id_modalidade: [],
          id_unidade_negocio: null
        },
        custom_filter: {}
      }
    },
    watch: {
      atualizaListagem () {
        this.filtrar()
      }
    },
    methods: {
      filtrar () {
        this.custom_filter = { ...this.filtro }
      },
      resetFilter () {
        this.filtro = {
          id_cadastro: null,
          id_produto: null,
          codigo_produto: '',
          nome_produto: '',
          id_flavor: [],
          id_empresa_newcon: [],
          id_modalidade: [],
          id_unidade_negocio: null
        }
        this.custom_filter = {}
      },
      editar (item) {
        this.$emit('editar', item)
      },
      async excluir (id_cadastro) {
        await this.$http.delete(`/painel/produtos/${id_cadastro}`).then(() => {
          notification(AlertTypes.SUCCESS, 'Produto excluído com sucesso!')
        }).catch(() => {
          notification(AlertTypes.ERROR, 'Tivemos um erro ao excluir o produto, sugerimos tentar novamente e se o problema persistir entre em contato com a Área de Suporte!')
        })
        this.filtrar()
      },
      downloadReport () {
        const filtros = { ...this.filtro }
        const headersExport = this.headers
          .filter(h => h.value)
          .map(h => h.value)

        const headersFormatadoExport = this.headers
          .filter(h => h.value)
          .map(h => h.text)

        const encoded_params = Qs.stringify({
          filter: filtros,
          pagination: { sortBy: this.params.pagination.sortBy, descending: this.params.pagination.descending },
          headers: headersExport,
          headers_formatado: headersFormatadoExport
        }, {
          arrayFormat: 'brackets',
          encode: true
        })

        try {
          window.open(`${this.ws}/produtos/exportar?${encoded_params}`)
        } catch (error) {
          notification(AlertTypes.ERROR, `${error.response?.data?.error || error.message}`)
        }
      },
      confirmExcluir (id_cadastro) {
        alert({
          text: `Tem certeza que deseja excluir o produto selecionado?\n Os dados atuais serão perdidos.`,
          buttons: {
            'Cancelar': () => {},
            'Confirmar': () => this.excluir(id_cadastro)
          }
        })
      }
    }
  }
</script>

<style>
.v-btn:not(.v-btn--round).v-size--default.btn-acoes {
  padding: 0px;
  min-width: 0;
  width: 48px;
  margin-right: 10px;
}

.icon-rounded {
  border-radius: 50%;
  background-color:  var(--secondary);
  color: white;
  padding: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  font-size: 20px;
}

.codigo-background {
  background-color: #e0e0e0;
  padding: 8px;
  border-radius: 15px;
  font-size: 14px;
}
</style>
